import React, { useRef, useState } from 'react';
import styles from './thirdScreen.module.css';
import romi1 from '../../images/romy_6.webp';
import maximovaLogo from '../../images/maximova-logo.webp';
import FormModal from '../../components/formModal/FormModal';
import useScrollReveal from '../../hooks/useScrollReveal';

function ThirdScreen() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const sectionRef = useRef(null);
  useScrollReveal(sectionRef);

  return (
    <>
      <section className={styles.aboutSection} id="story" ref={sectionRef}>
        {/* Ambient glows */}
        <div className={styles.glowTopRight} />
        <div className={styles.glowBottomLeft} />
        <div className={styles.glowCenter} />

        {/* Floating sparkles */}
        {[...Array(15)].map((_, i) => (
          <div key={i} className={`${styles.sparkle} ${styles[`sp${i + 1}`]}`} />
        ))}

        {/* Decorative arcs */}
        <div className={styles.arcLeft} />
        <div className={styles.arcRight} />

        {/* Diagonal ribbon  -  echoing hero */}
        <div className={styles.ribbonWrap}>
          <div className={styles.ribbonTrack}>
            {[0, 1].map((i) => (
              <div className={styles.ribbonSlide} key={i} aria-hidden={i > 0}>
                {[...Array(8)].map((_, j) => (
                  <React.Fragment key={j}>
                    <span className={styles.ribbonText}>המאסטרית רומי פרץ</span>
                    <span className={styles.ribbonBrand}>Maximova</span>
                    <span className={styles.ribbonDot}>✦</span>
                  </React.Fragment>
                ))}
              </div>
            ))}
          </div>
        </div>

        <div className={styles.container}>
          {/* ── Image column (left side) ── */}
          <div className={styles.imageWrapper}>
            <img src={romi1} alt="רומי פרץ" className={styles.image} loading="lazy" />
          </div>

          {/* ── Text column (right side) ── */}
          <div className={styles.content}>
            <h1 className={styles.mainTitle} data-sr="0">נעים מאוד, אני רומי פרץ</h1>


            <div className={styles.textBlock} data-sr="0.12">
              <p className={styles.paragraph}>
                מגיל קטן ידעתי שעולם היופי מושך אותי. לא ידעתי להסביר את זה ולא ידעתי מה לעשות עם זה - אבל הרצון להתחיל והתשוקה תמיד היו שם.
              </p>
            </div>

            <div className={styles.divider} />

            <div className={styles.textBlock} data-sr="0.16">
              <p className={styles.paragraph}>
                החלטתי שאני מתחילה. <strong>אפס נסיון, אפס ידע מקדים.</strong> רק אהבה לתחום ותחושה שאני חייבת לנסות.
              </p>
              <p className={styles.paragraph}>
                הלכתי ללמוד עיצוב גבות. תרגלתי, טעיתי, היו ימים שהייתי בטוחה שיש לי שתי ידיים שמאליות ושהתחום הזה פשוט לא בשבילי. <strong>אבל משהו בפנים לא נתן לי לעזוב.</strong> הוספתי את הריסים - ומשם הכל השתנה.
              </p>
            </div>

            <div className={styles.divider} />

            <div className={styles.textBlock} data-sr="0.24">
              <p className={styles.paragraph}>
                היום אני מדריכה בינלאומית ב-<img src={maximovaLogo} alt="Maximova" className={styles.maxLogoInline} loading="lazy" /> - חברה איטלקית שפועלת ב-60 מדינות, הראשונה בארץ עם אישור משרד הבריאות בתחום הרמת ריסים. יש 7 מדריכות בישראל ואני אחת מהן.
              </p>
            </div>

            <div className={styles.divider} />

            <div className={styles.textBlock} data-sr="0.28">
              <p className={styles.paragraph}>
                כשנכנסתי לעולם ההדרכה הבטחתי לעצמי דבר אחד - לא למכור חלומות לאף אחת. כי אני זוכרת בדיוק איך זה כשמישהו מבטיח לך שתוך חודשיים היומן מפוצץ, ואת נשארת לבד עם תעודה במגירה ובלי לקוחה אחת.
              </p>
              <p className={styles.paragraph}>
                מה שאני כן יכולה להבטיח לך זה שאם יש לך את הרצון ואת התשוקה, אני אתן לך <strong>את הכל.</strong> את כל הידע שצברתי על הבשר שלי, את החומרים הכי טובים שיש בארץ, תעודה בינלאומית שתפתח לך דלתות, וליווי אישי שלא נגמר ברגע שהקורס נגמר.
              </p>
            </div>

            <p className={styles.finalText} data-sr="0.32">
              אצלי אין סתם תלמידות - <em>אצלי בונות קריירה אמיתית.</em>
            </p>

            <button className={styles.ctaButton} data-sr="0.36" onClick={() => setIsFormOpen(true)}>
              תלחצי כאן ואנחנו מדברות
              <span className={styles.buttonIcon}>→</span>
            </button>
          </div>
        </div>
      </section>

      <FormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
}

export default ThirdScreen;
